import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Box } from 'reflexbox';
import styled, { keyframes } from 'styled-components';

import * as graphql from '@treams/treams-network';
import { HeartIcon, Modal, Popover, tokens } from '@treams/treams-ui';

import ThankYouModal from '../../../kakapo-ui-kit/components/modals/ThankYouModal';

const pulse = keyframes`
	0%,
	100% {
		transform: scale(1);
	}
	14% {
		transform: scale(1.12);
	}
	28% {
		transform: scale(1);
	}
	42% {
		transform: scale(1.12);
	}
`;

const PulsingHeart = styled.span`
	display: inline-flex;
	animation: ${pulse} 1.6s ease-in-out infinite;
	transform-origin: center;

	@media (prefers-reduced-motion: reduce) {
		animation: none;
	}
`;

export default function ComplimentCreateThankYou(props: { userID: string }) {
	const query = graphql.useUserQuery({ variables: { id: props.userID } });

	return query.data ? (
		<ComplimentCreateThankYouElement user={query.data.user as graphql.User} />
	) : null;
}

const ComplimentCreateThankYouElement = ({ user }: { user: graphql.User }) => {
	const { t } = useTranslation();
	const history = useHistory();
	const returnUrl = `/feedback/compliments`;

	return (
		<Popover center visible>
			<Modal>
				<Modal.Header
					title={t('compliments.thankYou.title')}
					onClose={() => {
						history.push(returnUrl);
					}}
				/>

				<Box mb={3}>
					<ThankYouModal
						title={t('compliments.thankYou.description', { firstName: user.firstName })}
						buttonTitle={t('compliments.thankYou.backButton.title', { firstName: user.firstName })}
						contentMarginTop={4}
						icon={
							<PulsingHeart>
								<HeartIcon
									size={56}
									solid
									color={tokens.brand.icon}
									aria-hidden
								/>
							</PulsingHeart>
						}
						onClick={() => {
							history.push(returnUrl);
						}}
					/>
				</Box>
			</Modal>
		</Popover>
	);
};
